
const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

module.exports = clamp
